import { useParams } from 'react-router-dom';

export const useWorkspaceTranscriptParams = () => {
  const { transcriptId } = useParams<Stringify<ITranscriptId>>();

  return {
    transcriptId: transcriptId ? +transcriptId : null,
  };
};